<script>
export default {
    name: 'BaseInput',

    inheritAttrs: false,

    props: {
        value: {
            type: String,
        },
    },

    data() {
        return {
            focused: false,
            uid: undefined,
        }
    },

    mounted() {
        const inBrowser = typeof window !== 'undefined'
        if (inBrowser) {
            this.uid = this.$attrs.id ? this.$attrs.id : 'input' + Math.random()
        }
    },
}
</script>

<template>
    <div
        class="base-input"
        :class="{
            ...$attrs.class,
            'has-value': value && value.length,
            focused: focused,
        }"
    >
        <label :for="`${uid}`">
            <div class="label-text">
                <slot name="label" />
            </div>
        </label>
        <div class="input-wrapper">
            <div class="before">
                <slot name="before" />
            </div>
            <input
                @focus="focused = true"
                @blur="focused = false"
                v-on="$listeners"
                :value="value"
                :id="`${uid}`"
                v-bind="$attrs"
            />
            <div class="after">
                <slot name="after" />
            </div>
        </div>
    </div>
</template>
<style lang="stylus">
@import '../assets/stylus/vars.styl'

.base-input
    font-size 1.4em
    display block
    position relative
    cursor text

    .label-text
    input
        // padding-left 1em
        // padding-right 1em

    label
        padding-left 2em
        cursor text
        z-index 1
        display block
        padding-bottom 3px

    .label-text
        display block
        // color $AkGreyscaleBlack
        color $AkBlack

    .input-wrapper
        box-sizing border-box
        display flex
        align-items center
        opacity 1
        border 1px solid var(--color3)
        border-radius 9999px
        background $AkWhite
        height 3em
        font-size inherit
        padding-left 2em
        padding-right 2em

        input
            flex-grow 1
            flex-shrink 1
            border 0
            min-width 0
            height 100%
            box-sizing border-box
            color var(--AkGreyscaleBlack)
            font-family inherit
            font-size inherit

            &::placeholder
                transition color ease 0s
                color var(--AkGreyscaleMediumGrey)

            &:focus-visible
                outline 0

                &::placeholder
                    transition color ease .3s .1s
                    color var(--AkGreyscaleMediumGrey)

        &:has(:focus-visible)
            border-color black
            outline 1px solid black

    &.focused
    &.has-value
        label
            z-index 0

        .label-text
            font-weight normal
            color var(--color5)

        .input-wrapper
            opacity 1

    &.focused
        border-color var(--color5)

    &.has-errors:not(.focused)
        .input-wrapper
            border-color $AkMajorCoral

        .label-text
            color $AkMajorCoral

        .after
        .before
            color $AkMajorCoral
    
    &.is-success:not(.focused)
        .input-wrapper
            border-color $AkMajorGreen

        .label-text
            color $AkMajorGreen

        .after
        .before
            color $AkMajorGreen

    &.base-input-small
        font-size 1.15em
</style>
